<template>
    <div v-show="visible">
        <el-dialog title="必须打卡日期" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="460px"> 
            日期
            <el-date-picker style="width:140px;"
                v-model="form.date"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd">
            </el-date-picker> 
            <br/>
            <!-- 班次管理 -->
            <div style="margin-top:20px;text-align:right;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.name" placeholder="班次名称"></el-input>
                    </div>
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="getData()">查询</el-button>
                </div>
            </div>
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                height="200"
                border
                default-expand-all>
                <el-table-column prop="" width="55" >
                    <template slot-scope="scope">
                        <el-radio class="radio" v-model="radio" :label="scope.row.id">&nbsp;</el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="班次名称"></el-table-column>
                <el-table-column prop="" label="考勤时间">
                    <template slot-scope="scope">
                        <div v-if="scope.row.classesType == 1">
                            {{scope.row.oneCommuteTime}}
                        </div>
                        <div v-else-if="scope.row.classesType == 2">
                            {{scope.row.oneCommuteTime}}&nbsp;{{scope.row.twoCommuteTime}}
                        </div>
                        <div v-else-if="scope.row.classesType == 3">
                            {{scope.row.oneCommuteTime}}&nbsp;{{scope.row.twoCommuteTime}}&nbsp;{{scope.row.threeCommuteTime}}
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span> 
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../common/http'; 
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible:false,
                form:{
                    name:"",
                    date:""
                },
                radio:"",
                data:[],
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                }
            }
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        created:function () {
        },
        methods:{
            init(){
                this.visible=true;
                // 初始化班次
                this.getData();
                this.form.date="";
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){
                let url  = this.listClassesDataUrl;
                let data = {
                    name:this.form.name
                };
                // console.log(JSON.stringify(data));
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data));
                    if(res.status==200){
                       this.data = res.data.list;  
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                if(this.$util.isEmpty(this.form.date) || 
                    this.$util.isEmpty(this.radio)){
                    this.$commonFn.showTip('日期或者班次不可为空',3);
                    return;
                }
                // 获取当前选中那行数据
                let rowData={};
                for(var i=0;i<this.data.length;i++){
                    let tempData=this.data[i];
                    if(tempData.id == this.radio){
                        rowData=tempData;
                        break;
                    }
                }
                
                let specialDate={};
                specialDate.date=this.form.date;
                specialDate.classesId=rowData.id;
                specialDate.className=rowData.name;
                specialDate.classesType=rowData.classesType;
                specialDate.oneCommuteTime=rowData.oneCommuteTime;
                specialDate.twoCommuteTime=rowData.twoCommuteTime;
                specialDate.threeCommuteTime=rowData.threeCommuteTime;
                specialDate.flag=1;
                // console.log("当前添加日期"+JSON.stringify(specialDate));
                // 赋值给上一个父级窗体
                this.$parent.addDateClasses(specialDate);
                this.visible=false;
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/attendance/group/AddDateClasses.vue